<template>
	<div :class="buttonClass" @click="handleHome">
		<!-- PC版本 -->
		<template v-if="mode === 'pc'">
			<SvgIcons name="icon_home" class="c-action-svg" />
			<span class="action-block-span">{{ homeLabel }}</span>
		</template>

		<!-- 移动端版本 -->
		<template v-else>
			<SvgIcons name="icon_home" class="mobile-action-svg" />
		</template>
	</div>
</template>

<script setup>
import { computed, inject } from 'vue';
import i18n, { EN } from '@/locales';

const mode = inject('mode');
const buttonClass = inject('roundButtonClass');

const homeLabel = computed(() => {
	return i18n.t('enterprise.sie-home');
});
const handleHome = () => {
	if (i18n.locale === EN) {
		window.open('https://www.sie-intl.com', '_blank');
	} else {
		window.open('https://www.chinasie.com', '_blank');
	}
};
</script>
